import { Box } from '@mui/material';
import PropTypes from 'prop-types';

// Our Components
import Modal from 'components/Modal/Modal';
import { PrimaryButton, SecondaryButton } from 'components/Button/Button';
import Loader from 'components/Loader';

function ConfirmKeyActionChange({
	isOpen,
	handleClose,
	title,
	subtitle,
	primaryButtonText,
	confirmButtonCallback,
	isConfirmButtonLoading,
	disable,
	children
}) {
	return (
		<Modal
			isOpen={isOpen}
			handleClose={handleClose}
			title={title}
			subtitle={subtitle}
		>
			{children}
			<Box sx={{ display: 'flex', gap: 2 }}>
				{isConfirmButtonLoading && <Loader />}
				{!isConfirmButtonLoading && (
					<PrimaryButton
						onClick={confirmButtonCallback}
						isDisabled={disable}
					>
						{primaryButtonText}
					</PrimaryButton>
				)}

				<SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
			</Box>
		</Modal>
	);
}

ConfirmKeyActionChange.propTypes = {
	primaryButtonText: PropTypes.string.isRequired,
	confirmButtonCallback: PropTypes.func.isRequired,
	disable: PropTypes.bool
};

ConfirmKeyActionChange.defaultProps = {
	primaryButtonText: 'Archive',
	disable: false
};

export default ConfirmKeyActionChange;
